export const zhHK = {
  minLength: "至少 8 個字元",
  asciiOnly: "僅允許 ASCII 字元",
  uppercaseRequired: "至少一個大寫字母（A–Z）",
  lowercaseRequired: "至少一個小寫字母（a–z）",
  numberOrSpecialRequired: "至少一個數字或特殊字元（例如 @、#、$、%、!）",
};
